import { defaultMaxValue } from '../constants';
import { IInstrument, IRealPrice } from '../types';
import { getMaxDigitWithDot } from '@trader/utils';
import {
  calculateProfitPips,
  calculateStopLossPips,
} from '../utils/pipsCalculating';
import { calculateIndicesPips } from '../utils/indicesPips';

interface IUseTradingProtectionOutput {
  maxLossValue: number;
  minLossValue: number;
  maxProfitValue: number;
  minProfitValue: number;
  isSwitchLoss: boolean;
  isSwitchProfit: boolean;
  marketAmount: string;
  maxLimitValue: number;
  minLimitValue: number;
}

export const useTradingProtection = (
  instrument: IInstrument,
  realTimePrice: IRealPrice
): IUseTradingProtectionOutput => {
  const {
    market: {
      protection: { isSwitchLoss, isSwitchProfit, stopsLevel },
      billType: selectedButton,
      amountVolume: marketAmount,
    },
    limit: { billType: limitBillType },
    general: { pipSize },
  } = instrument;

  const { ask, bid } = realTimePrice;

  const fixDigit = getMaxDigitWithDot(pipSize);
  const maxLossValue =
    selectedButton === 'Buy'
      ? Number(
          calculateStopLossPips({
            ask,
            bid,
            side: selectedButton,
            pipSize,
            stopsLevel: +calculateIndicesPips(stopsLevel, 'toPips'),
            fixDigit,
          })
        )
      : defaultMaxValue;
  const minLossValue =
    selectedButton === 'Buy'
      ? pipSize
      : Number(
          calculateStopLossPips({
            ask,
            bid,
            side: selectedButton,
            pipSize,
            stopsLevel: +calculateIndicesPips(stopsLevel, 'toPips'),
            fixDigit,
          })
        );

  const maxProfitValue =
    selectedButton === 'Buy'
      ? defaultMaxValue
      : Number(
          calculateProfitPips({
            ask,
            bid,
            side: selectedButton,
            pipSize,
            stopsLevel: +calculateIndicesPips(stopsLevel, 'toPips'),
            fixDigit,
          })
        );
  const minProfitValue =
    selectedButton === 'Buy'
      ? Number(
          calculateProfitPips({
            ask,
            bid,
            side: selectedButton,
            pipSize,
            stopsLevel: +calculateIndicesPips(stopsLevel, 'toPips'),
            fixDigit,
          })
        )
      : pipSize;

  const minLimitValue = limitBillType === 'Buy' ? pipSize : Number(ask);
  const maxLimitValue = limitBillType === 'Buy' ? Number(bid) : defaultMaxValue;

  return {
    maxLossValue,
    minLossValue,
    maxProfitValue,
    minProfitValue,
    isSwitchLoss,
    isSwitchProfit,
    marketAmount,
    maxLimitValue,
    minLimitValue,
  };
};
